import React, { useState, useCallback } from "react";
import MockInstruction from "../../components/SatCourse/MockInstruction";
import { useLocation, useNavigate } from "react-router-dom";

export interface MockInstructionScreenProps {}

const MockInstructionScreen: React.FC<MockInstructionScreenProps> = (props) => {
  const useLocations = useLocation();
  const navigate = useNavigate();
  const title = useLocations.state?.title || "";
  
  const [isLoading] = useState<boolean>(false);
  const [isError] = useState<string>("");
  
  const HandleId = useCallback(() => {
    navigate("/mocktestreading", { state: { title: title } });
  }, [navigate, title]);

  return (
    <>
      <MockInstruction
        isLoading={isLoading}
        isError={isError}
        title={title}
        HandleId={HandleId}
      />
    </>
  );
};
export default MockInstructionScreen;
